import { render } from "./SalesListPage.vue?vue&type=template&id=5aa529af&ts=true"
import script from "./SalesListPage.vue?vue&type=script&lang=ts"
export * from "./SalesListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__